// extracted by mini-css-extract-plugin
export default {"wrapper":"summary-card_wrapper__b-Q9l","title":"summary-card_title__T4mit","counter":"summary-card_counter__PeZfV"};